import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../../config/FlowTypes';
import { useAppStore } from '../../../store/Store';
import { NavigationProps } from '../FlowNavigation';
import {
  CoverageResultsLayout,
  CoverageResultsLayoutConfig,
} from '../layouts/CoverageResultsLayout';

export type CoverageResultsScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.CoverageResults,
  CoverageResultsLayoutConfig,
  ScreenNames
> & {
  /** Screen the "other financial assistance" card jumps to (the PAP flow). Omit to hide the card. */
  assistanceScreen?: ScreenNames;
};

type Props<ScreenNames extends string> = NavigationProps<
  CoverageResultsScreenConfig<ScreenNames>,
  ScreenNames
>;

/**
 * Coverage results after the US address step or the AU membership number. The insurer request goes
 * to the account email; Control users reach this screen before signing up, so it may not be known
 * yet and the sentence is then omitted.
 */
export const CoverageResultsScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const { navigation, layout, assistanceScreen } = props;
  const email = useAppStore((state) => state.user.email);

  return (
    <CoverageResultsLayout
      {...layout}
      email={email}
      onPressPrimaryButton={() => navigation.next(props)}
      onPressAssistance={
        assistanceScreen === undefined ? undefined : () => navigation.goTo(assistanceScreen)
      }
    />
  );
};
